'use client';
// Îlot INTERACTIF du calculateur — volontairement petit.
//
// ⚠️ Tout ce qui compte pour un moteur de recherche est rendu CÔTÉ SERVEUR par
// _render.js : la grille, le détail au minimum sectoriel, l'écart entre
// statuts. Cet îlot n'ajoute que la possibilité de bouger le curseur.
// C'est la leçon du 22/08 : la page d'accueil ne servait que « Chargement… »
// aux robots parce que TOUT y était côté client. Ici, si le JavaScript ne
// s'exécute jamais, la page reste complète et chiffrée.
import { useState } from 'react';
import { calculer } from './_calc';
import { T, euro } from './_i18n';

// R4 : les sous-composants sont définis au niveau du module, jamais dans un return().
function Ligne({ label, valeur, negatif, fort }) {
  return (
    <div style={{ display: 'flex', justifyContent: 'space-between', padding: '10px 0', borderBottom: '1px solid #e0ddd5' }}>
      <span style={{ fontSize: 14, color: fort ? '#1a1a18' : '#666', fontWeight: fort ? 700 : 400 }}>{label}</span>
      <span style={{ fontSize: fort ? 16 : 14, fontWeight: fort ? 800 : 600, color: negatif ? '#ef4444' : fort ? '#c6a34e' : '#1a1a18' }}>{valeur}</span>
    </div>
  );
}

export default function Interactif({ cpKey, minimum, lang = 'fr' }) {
  const t = T[lang];
  const depart = Math.max(1000, Math.round(minimum || 2500));
  const [brut, setBrut] = useState(depart);
  const [statut, setStatut] = useState('employe');
  const r = calculer(brut, { statut, cp: cpKey });
  if (!r) return null;

  return (
    <div style={{ background: '#fff', border: '2px solid #c6a34e', borderRadius: 16, padding: 24, marginBottom: 28 }}>
      <label htmlFor="brut-slider" style={{ fontSize: 15, fontWeight: 700, color: '#1a1a18', display: 'block', marginBottom: 6 }}>
        {t.lBrut}
      </label>
      <div style={{ fontSize: 34, fontWeight: 900, color: '#c6a34e', marginBottom: 10 }}>{euro(brut, lang)}</div>
      <input
        id="brut-slider"
        type="range"
        min={1000}
        max={8000}
        step={50}
        value={brut}
        onChange={(e) => setBrut(Number(e.target.value))}
        style={{ width: '100%', accentColor: '#c6a34e', marginBottom: 16 }}
      />

      <div role="group" aria-label={t.h2Statut} style={{ display: 'flex', gap: 8, marginBottom: 18 }}>
        {[['employe', t.statutEmploye], ['ouvrier', t.statutOuvrier]].map(([v, l]) => (
          <button
            key={v}
            type="button"
            onClick={() => setStatut(v)}
            aria-pressed={statut === v}
            style={{
              flex: 1, padding: '9px 12px', borderRadius: 9, fontSize: 14, fontWeight: 700, cursor: 'pointer',
              border: statut === v ? '2px solid #c6a34e' : '1px solid #ddd',
              background: statut === v ? '#fdf9ee' : '#fff',
              color: statut === v ? '#8a6f2e' : '#666',
            }}
          >
            {l}
          </button>
        ))}
      </div>

      <Ligne label={t.lOnss} valeur={'− ' + euro(r.onssTravailleur, lang)} negatif />
      {r.bonusEmploi > 0 && <Ligne label={t.lBonus} valeur={'+ ' + euro(r.bonusEmploi, lang)} />}
      <Ligne label={t.lImposable} valeur={euro(r.imposable, lang)} />
      <Ligne label={t.lPP} valeur={'− ' + euro(r.precompte, lang)} negatif />
      <Ligne label={t.lCsss} valeur={'− ' + euro(r.csss, lang)} negatif />
      <Ligne label={t.lNet} valeur={euro(r.net, lang)} fort />
      <Ligne label={t.lCout} valeur={euro(r.coutEmployeur, lang)} />
      {/* ⚠️ « dont » CORRIGÉ EN « + » LE 25/08/2026. Le libellé disait « dont
          fonds sectoriel », donc que le fonds était COMPRIS dans le coût total
          au-dessus. Il ne l'est pas : `coutEmployeurComplet` est calculé sans
          la moindre commission paritaire (ONSS patronal, AT, FFE, médecine du
          travail, ONVA). Le fonds S'AJOUTE — le widget d'embed l'écrivait déjà
          avec un « + », les deux écrans se contredisaient. */}
      {r.fondsSectoriel != null && r.fondsSectoriel > 0 && (
        <Ligne label={t.lFonds} valeur={euro(r.fondsSectoriel, lang)} />
      )}
      {/* Ligne SÉPARÉE : le second pilier n'est pas un fonds de sécurité
          d'existence, et le ranger sous la même étiquette rendrait le total
          juste et le libellé faux. */}
      {r.pensionSectorielle != null && r.pensionSectorielle > 0 && (
        <Ligne label={t.lPension} valeur={euro(r.pensionSectorielle, lang)} />
      )}
    </div>
  );
}
